import React from 'react'

const ContentBox = ({imgPath, title, text, stripColor}) => {

  return (
    <div className='col-12 col-lg-6'>
      <div className='Service-box wow animate__animated animate__fadeInLeft'>
        <div className='Service-box-logo'>
          <div>
            <img src={imgPath} alt='ICON'/>
          </div>
        </div>
        <h3 className={'Service-box__title ' + stripColor}>{title}</h3>
        <p className='Service-box__text'>{text}</p>
      </div>
    </div>
  )
}

export default ContentBox